import React from "react";
import {Card, Col, Container, Label, Row} from 'reactstrap';

import {Link, useParams} from "react-router-dom";
import AuthSlider from "./authCarousel";


const Unsubscribe = (props) => {
    const {status} = useParams();

    return (
        <React.Fragment>
            <div
                className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>

                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider/>

                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">

                                                <div>
                                                    <h5 className="text-primary">Confirmação de Cancelamento!     {status === "success" ? (
                                                        <i className="fas fa-circle-check"
                                                           style={{color: "green"}}/>
                                                    ) : (
                                                        <i className="fas fa-circle-exclamation"
                                                           style={{color: "red"}}/>
                                                    )}</h5>

                                                </div>
                                                <div className="mt-4 align-center">

                                                    <h2 className="login-success-icon align-center">

                                                    </h2>
                                                    <div className="login-title">
                                                        <h3></h3>
                                                        <p className="mb-0">
                                                            {status === "success"
                                                                ? "Seu cancelamento foi realizado com sucesso."
                                                                : "Houve um erro ao processar sua solicitação de cancelamento."}
                                                        </p>
                                                    </div>
                                                    <div className="form-group mb-0 mt-5">
                                                        <a className="btn btn-primary w-100" href="https://www.plantaorapido.com.br/">
                                                            Voltar para Home
                                                        </a>

                                                    </div>


                                                    {/*<div className="mt-4 text-center">*/}
                                                    {/*    <p className="mb-0">Não tem uma conta? <Link to="/register"*/}
                                                    {/*                                                 className="fw-semibold text-primary text-decoration-underline"> Registrar </Link>*/}
                                                    {/*    </p>*/}

                                                    {/*</div>*/}
                                                </div>
                                            </div>

                                        </Col>

                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()} <a
                                        className="text-reset text-decoration-none" target="_blank"
                                        href="https://medr.com.br/">MEDR</a>. Todos Direitos
                                        Reservados</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>

            </div>
        </React.Fragment>

    );
};

export default Unsubscribe;
